export default "__VITE_PUBLIC_ASSET__1221a345__"